import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IPendingWithdrawalDenyFields } from '../types';
import {
  PENDING_WITHDRAWALS_DENY_MUTATION_KEY,
  PENDING_WITHDRAWALS_DENY_URL,
  PENDING_WITHDRAWALS_LIST_QUERY_KEY,
  PENDING_WITHDRAWALS_PERMISSIONS,
} from '../constants';

export default function usePendingWithdrawalsDenyMutation(): IContextMutationResult<
  void,
  Error,
  IPendingWithdrawalDenyFields
> {
  const { displayPresetToast } = useToastStore();
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IPendingWithdrawalDenyFields>({
    mutationKey: [PENDING_WITHDRAWALS_DENY_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      PENDING_WITHDRAWALS_DENY_URL,
      payload,
      {
        permission: PENDING_WITHDRAWALS_PERMISSIONS.EDIT,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success');
      void queryClient.invalidateQueries({ queryKey: [PENDING_WITHDRAWALS_LIST_QUERY_KEY] });
    },
  });
}
